import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useHistory } from 'react-router';
import Logo from '../../components/voxel/Logo/Logo';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelText from '../../components/voxel/Text/VoxelText';

export interface SignUpSuccessProps { }

export const SignUpSuccess: React.FC<SignUpSuccessProps> = ({ }) => {
  const history = useHistory();
  return (
    <div className={`w-full h-screen bg-white flex flex-row relative`}>
      <div className="w-auto h-auto absolute top-8 left-8">
        <Logo size="xs" />
      </div>
      <div className="mt-64 mx-auto w-[500px] flex flex-col items-center gap-16">
        <div>
          <VoxelText
            userSelectClass="select-none"
            className="whitespace-pre-line font-semibold"
            variant="title1"
          >
            You're all set!
          </VoxelText>
        </div>
        <div className="flex flex-row justify-center items-center gap-3 w-full pb-20">
          <VoxelButton
            title="Start using Voxel"
            color="primary"
            size="xl"
            className="w-48"
            endIcon={<FontAwesomeIcon icon={faArrowRight} />}
            onClick={() => history.push('/')}
          />
        </div>
      </div>
    </div>
  );
};

export default SignUpSuccess;
